import axiosBackEnd from "../config/axios/axios-back-end";

export const reportUpdateReportCategory = async (apiData) => {
  const { id, data } = apiData;
  const response = await axiosBackEnd.post(
    `/api/reports/${id}/report-category`,
    data,
  );
  return response.data;
};

export const reportUpdateReport = async (reportData) => {
  const { id, data } = reportData;
  const response = await axiosBackEnd.put(`/api/reports/${id}`, data);
  return response.data;
};

export const reportDeleteReport = async (reportData) => {
  const { id, hotel_id } = reportData;
  const response = await axiosBackEnd.delete(`/api/reports/${id}`, {
    data: {
      hotel_id,
    },
  });
  return response.data;
};

export const reportDeleteHotelReports = async (reportData) => {
  const { hotelId, reportIds } = reportData;
  const response = await axiosBackEnd.delete(`/api/hotels/${hotelId}/reports`, {
    data: {
      reportIds,
    },
  });
  return response.data;
};

export const reportUpdateReportList = async (data) => {
  const response = await axiosBackEnd.put("/api/reports/bulk", data);
  return response.data;
};

export const reportCreateReportList = async (data) => {
  const response = await axiosBackEnd.post("/api/reports/bulk", data);
  return response.data;
};

export default {
  reportUpdateReportCategory,
  reportUpdateReport,
  reportDeleteReport,
  reportUpdateReportList,
  reportCreateReportList,
  reportDeleteHotelReports,
};
